export const isUndefinedOrEmpty = (value: string | undefined): boolean => {
	return typeof value === "undefined" || isEmpty(value);
};

export const isEmpty = (value: string = ""): boolean => {
	return /^\s*$/.test(value);
};

export const oneMoreWords = (num: string = ""): string => (num.length === 1 ? `${num}.0` : num);
